import { cn } from "@drpcrd/utils/shared";
import { ClassValue } from "clsx";
import { ReactNode } from "react";

type Props = {
  className?: ClassValue;
  children?: ReactNode;
};

/**
 * The standard content constraint for creator pages.
 * Extracted so it can be used manually when `disableContentWrapper` is active.
 */
export const CreatorPageContentWrapper = ({ className, children }: Props) => (
  <div
    className={cn(
      "flex w-full max-w-56 grow flex-col px-2 sm:!px-1",
      className,
    )}
  >
    {children}
  </div>
);
